import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface SideNavigatorContainerProps {
    showDrawer?: boolean
}

export const TemplateContainer = styled.div<SideNavigatorContainerProps>`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    width: 100%;

    .nav-bar-content {
        display: flex;
        height: 100%;
        width: 100%;
        gap: ${({ theme }): string => theme.spacing[600]};
        flex-direction: row;
        @media screen and (max-width: 768px) {
            flex-direction: column;
            overflow-y: auto;
        }
        @media (min-width: 1024px) {
            padding-bottom: 24px;
        }
    }
    .small-sidebar-content {
        width: 100%;
        @media screen and (min-width: 768px) {
            display: none;
        }
        .open-small-sidebar {
            width: 100%;
            align-self: flex-start;
            display: flex;
            flex-direction: column;
            gap: ${theme.newSpacing.xxs};
            box-sizing: border-box;
            .current-page-open-button {
                display: flex;
                width: 100%;
                justify-content: space-between;
                border: 1px solid ${theme.newColors.neutral200};
                border-radius: 4px;
                align-items: center;
                box-sizing: border-box;
                height: 38px;
                padding: 9px ${theme.newSpacing.s};
            }
        }
    }
    .small-device-sidebar {
        position: fixed;
        width: 100vw;
        top: 0;
        left: 0;
        height: 100vh;
        background-color: rgba(1, 1, 1, 0.4);
        .side-navigator-content {
            height: 100%;
            width: fit-content;
            padding: 24px;
            background: ${({ theme }): string => theme.colors.surface.primary};
        }
    }
    .sidebar-divider {
        width: 1px;
        background: ${({ theme }): string => theme.colors.divider.primary};
        @media screen and (max-width: 768px) {
            display: none;
        }
    }
    .top-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0 24px 0;
        @media screen and (max-width: 768px) {
            margin: 0px;
            align-items: baseline;
        }
        .content-block {
            display: flex;
            gap: ${({ theme }): string => theme.spacing[200]};
            align-items: center;
        }
    }
    .right-block {
        width: 0px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        gap: ${({ theme }): string => theme.spacing[400]};
        height: 0px;
        transition: width 0.3s ease-in-out;

        &.show {
            padding-right: 24px;
            width: 418px;
            height: calc(100vh - 152px);
            @media (min-width: 1024px) {
                height: calc(100vh - 176px);
            }
        }

        @media screen and (max-width: 768px) {
            position: fixed;
            left: 0;
            width: 100%;
            height: 100%;
            bottom: -100%; /* Start off-screen at the bottom for mobile */
            padding-right: 24px;
            margin: 0px;
            justify-content: flex-end;
            background-color: rgba(0, 0, 0, 0.5);
            transition: transform 0.3s ease-in-out;
            transform: none; /* Reset transform for mobile */

            &.show {
                width: 100%;
                transform: translateY(-100%); /* Slide up for mobile */
                transition: transform 0.3s ease-in-out;
                z-index: 999;
                height: 100%;
            }
        }
    }
    .right-block-inner-container {
        @media screen and (max-width: 768px) {
            box-sizing: border-box;
            display: flex;
            overflow-y: auto;
            flex-direction: column;
            background-color: ${({ theme }): string => theme.colors.background.secondary};
            position: relative;
            height: 90%;
            max-height: 90%;
            gap: 24px;
            padding-top: 40px;
            align-items: center;

            .comments-center {
                position: absolute;
                width: 100%;
                left: 0;

                .comment-center-container {
                    height: 100%;
                    max-height: 100%;
                }
            }
        }
    }
    .comments-center {
        width: 100%;
    }
    .preview-title-block {
        width: 375px;
        display: flex;
        flex-direction: column;
        gap: ${({ theme }): string => theme.spacing[200]};
        margin-bottom: 16px;

        .preview-close {
            display: block;
            position: absolute;
            right: 16px;
            top: 16px;
        }
    }
    .app-preview-title {
        display: flex;
        flex-direction: row;
        gap: ${({ theme }): string => theme.spacing[200]};
    }
    .form-content {
        flex: 1;
        height: calc(100vh - 152px);
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .form-fields {
            flex: 1;
            overflow-y: auto;
        }
        @media screen and (max-width: 1024px) {
            padding: 0;
        }
        @media screen and (max-width: 768px) {
            padding: 0;
            height: calc(100vh - 380px);
        }
        @media (min-width: 1024px) {
            height: calc(100vh - 176px);
        }
    }
    .side-navigator {
        @media screen and (min-width: 1024px) {
            width: ${({ showDrawer }) => (showDrawer ? 'fit-content' : '300px')};
        }
        @media screen and (min-width: 768px) and (max-width: 1024px) {
            width: ${({ showDrawer }) => (showDrawer ? 'fit-content' : '200px')};
        }
        @media screen and (max-width: 768px) {
            display: none;
        }
        height: fit-content;
    }
`

export const TemplateContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 770px;
    margin-bottom: 30px;
    gap: ${({ theme }): string => theme.spacing[600]};
    .form-title {
        display: flex;
        gap: ${({ theme }): string => theme.spacing[200]};
    }
    .button {
        width: 120px;
    }
`

export const DefaultBannerContainer = styled.div`
    background: ${({ theme }) => theme.colors.surface.infoPastel};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    padding: 12px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[400]};
`
